module.exports = __webpack_public_path__ + "img/vojtech.9e8facdd.jpg";